var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-broadcast-tower" }
          }),
          _vm._v(" " + _vm._s(_vm.$t(_vm.title_webcasts)) + "\n        ")
        ],
        1
      ),
      _c(
        "q-tabs",
        {
          key: _vm.webcastTabsKey,
          staticClass: "shadow-1",
          attrs: { color: "secondary" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "event_data",
              label: _vm.$t("event_data")
            },
            slot: "title"
          }),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTab,
                expression: "showTab"
              }
            ],
            attrs: {
              slot: "title",
              name: "subscribers",
              label: _vm.$t("subscribers")
            },
            slot: "title"
          }),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTab,
                expression: "showTab"
              }
            ],
            attrs: { slot: "title", name: "tests", label: _vm.$t("tests") },
            slot: "title"
          }),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTab,
                expression: "showTab"
              }
            ],
            attrs: {
              slot: "title",
              name: "support_material",
              label: _vm.$t("support_materials")
            },
            slot: "title"
          }),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTab,
                expression: "showTab"
              }
            ],
            attrs: {
              slot: "title",
              name: "reaction_tests",
              label: _vm.$t("reaction_tests")
            },
            slot: "title"
          }),
          _vm.showTab && _vm.show_stream
            ? _c("q-tab", {
                attrs: {
                  slot: "title",
                  name: "stream",
                  label: _vm.$t("stream")
                },
                slot: "title"
              })
            : _vm._e(),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTab && _vm.show_chat_moderation,
                expression: "showTab && show_chat_moderation"
              }
            ],
            attrs: {
              slot: "title",
              name: "chat_moderation",
              label: _vm.$t("chat_moderation")
            },
            slot: "title"
          }),
          _vm.useReviews
            ? _c("q-tab", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showTab,
                    expression: "showTab"
                  }
                ],
                attrs: {
                  slot: "title",
                  name: "comments",
                  label: _vm.$t("comments")
                },
                slot: "title"
              })
            : _vm._e(),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showPresence,
                expression: "showPresence"
              }
            ],
            attrs: {
              slot: "title",
              name: "presence",
              label: _vm.$t("presence")
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            {
              staticClass: "q-px-lg q-pb-xl",
              attrs: { name: "event_data", "keep-alive": "" }
            },
            [
              _c("event-data", {
                attrs: { manageWebcasts: _vm.permissions.webcasts_manage },
                on: { loadContent: _vm.loadContent }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            {
              staticClass: "q-px-lg q-pb-xl",
              attrs: { name: "subscribers", "keep-alive": "" }
            },
            [
              _c("subscribers", {
                attrs: { manageWebcasts: _vm.permissions.webcasts_manage }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            {
              staticClass: "q-px-lg q-pb-xl",
              attrs: { name: "tests", "keep-alive": "" }
            },
            [
              _c("tests", {
                attrs: { manageWebcasts: _vm.permissions.webcasts_manage }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "support_material" } },
            [
              _c("support-material", {
                attrs: { manageWebcasts: _vm.permissions.webcasts_manage }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            {
              staticClass: "q-px-lg q-pb-xl",
              attrs: { name: "reaction_tests", "keep-alive": "" }
            },
            [
              _c("reaction-tests", {
                attrs: { manageWebcasts: _vm.permissions.webcasts_manage }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            {
              staticClass: "q-px-lg q-pb-xl",
              attrs: { name: "stream", "keep-alive": "" }
            },
            [_c("stream", { attrs: { id_webcast: _vm.id_webcast } })],
            1
          ),
          _c(
            "q-tab-pane",
            {
              staticClass: "q-px-lg q-pb-xl",
              attrs: { name: "chat_moderation" }
            },
            [
              _c("chat-moderation", {
                attrs: { manageWebcasts: _vm.permissions.webcasts_manage }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "comments" } },
            [_c("comments", { attrs: { origin: "webcast" } })],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "presence" } },
            [_c("presence", { attrs: { url: _vm.presenceUrl } })],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }